module.exports = __webpack_public_path__ + "img/23.e352469c.jpg";